// Recorte de imagem via Canvas — recebe a área escolhida no react-easy-crop
// (em pixels da imagem original) e devolve um Blob JPEG já recortado e
// redimensionado. Mesma abordagem (canvas.toBlob, JPEG, qualidade 0.82) do
// compressImage() em eventService.js, só que extraindo uma sub-região em vez
// de redimensionar a imagem inteira — os dois nunca precisam rodar "um por
// cima do outro" porque uploadEventImage() já recomprime só se o resultado
// ainda estiver grande.
export function getCroppedImageBlob(imageSrc, croppedAreaPixels, { maxWidth = 1200, quality = 0.82 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const scale = Math.min(1, maxWidth / croppedAreaPixels.width);
      const targetWidth = Math.round(croppedAreaPixels.width * scale);
      const targetHeight = Math.round(croppedAreaPixels.height * scale);

      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        img,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        targetWidth,
        targetHeight
      );

      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Falha ao gerar imagem recortada'))),
        'image/jpeg',
        quality
      );
    };

    img.onerror = () => reject(new Error('Falha ao carregar imagem para recorte'));
    img.src = imageSrc;
  });
}
